import { BufferWriter, Writer } from "protobufjs";
import { NotificationCommon } from "../../../config/view_const/notification";
import { AppError, ErrorType } from "../../../domain/model/app_error";
import {
  IApplyClientRepository,
  TRegisterClientRequest,
} from "../../../domain/repository/apply_client_repository";
import { IApiClient } from "../client";
import { api } from "../rpc/api";
import RegisterClientRequest = api.RegisterClientRequest;

class ApplyClientAPI implements IApplyClientRepository {
  constructor(readonly apiClient: IApiClient) {}

  public register(
    registerClientRequest: TRegisterClientRequest
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const req: RegisterClientRequest = new RegisterClientRequest();
      req.email = registerClientRequest.email;
      req.phoneNumber = registerClientRequest.phoneNumber;
      req.companyName = registerClientRequest.companyName;
      req.webURL = registerClientRequest.webURL;
      req.accountName = registerClientRequest.accountName;
      req.accountNameKana = registerClientRequest.accountNameKana;
      req.department = registerClientRequest.department;
      req.position = registerClientRequest.position;
      req.source = registerClientRequest.source;
      req.isDemo = registerClientRequest.isDemo;
      req.demoPassword = registerClientRequest.demoPassword;
      req.routeInfo = registerClientRequest.routeInfo;
      const writer: BufferWriter | Writer = Writer.create();
      this.apiClient
        .post(
          "/api.ApplyClientService/Register",
          RegisterClientRequest.encode(req, writer).finish()
        )
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          if (
            error instanceof AppError &&
            error.type === ErrorType.API_REQUEST_409
          ) {
            reject(
              new AppError(
                error.code,
                ErrorType.FAIL_APPLY_CLIENT_EMAIL_ALREADY_USED,
                NotificationCommon.failureApplyClientEmailAlreadyUsed
              )
            );
            return;
          }
          reject(error);
        });
    });
  }
}

const createApplyClientAPI = (
  apiClient: IApiClient
): IApplyClientRepository => {
  return new ApplyClientAPI(apiClient);
};

export { createApplyClientAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/apply_client_api.ts